import { formatDistanceToNow } from 'date-fns';

export const formatDate = (value: string) => {
  if (!value) return '';

  const date = value.includes('Z') ? value : `${value}Z`;
  return formatDistanceToNow(date, { addSuffix: true });
};
